//import {decode} from 'jsonwebtoken';
import jwtDecode from "jwt-decode";
import React, {useReducer, createContext} from "react";
import {AUTH_TOKEN} from "../constants";

const initialState = {user: null}
const tokenExistence = localStorage.getItem(AUTH_TOKEN) && localStorage.getItem(AUTH_TOKEN) !== 'undefined'

if (tokenExistence) {
    const decodedToken = jwtDecode(localStorage.getItem(AUTH_TOKEN))

    if (decodedToken.exp * 1000 < Date.now()) {
        localStorage.removeItem(AUTH_TOKEN)
    } else {
        initialState.user = decodedToken
    }
}

const AuthContext = createContext(
    {
        user: null,
        login: (userData) => {
            //TODO look at this pogledaj ovo
        },
        logout: () => {
        }
    }
)


function authReducer(state, action) {
    switch (action.type) {
        case 'LOGIN':
            return {
                ...state,
                user: action.payload
            }
        case 'LOGOUT':
            return {
                ...state,
                user: null
            }
        default:
            return state
    }
}

function AuthProvider(props) {
    const [state, dispatch] = useReducer(authReducer, initialState)

    const login = (userData) => {
        localStorage.setItem(AUTH_TOKEN, userData.token)
        dispatch({
            type: 'LOGIN',
            payload: userData
        })
    }

    function logout() {
        localStorage.removeItem(AUTH_TOKEN)
        dispatch({
            type: 'LOGOUT'
        })
    }

    return (
        <AuthContext.Provider
            value={{
                user: state.user, login, logout
            }} {...props}
        />
    )

}

export {AuthContext, AuthProvider}